import React, { useState } from 'react';
import { TbChecklist, TbEye, TbTargetArrow, TbX } from 'react-icons/tb';
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from './ScrollToTop';

const Mision = () => {
  const [modalData, setModalData] = useState({ open: false, title: "", text: "" });

  const textoMisionCompleto = "Somos una entidad sin ánimo de lucro que resalta la importancia del trabajo pedagógico, la formación, el desarrollo educativo en diferentes áreas, en especial el agroindustrial, como generadoras de actividades económicas enfocadas en el progreso de comunidades vulnerables en vías de desarrollo, incluyendo en un mediano plazo la atención a la salud, derechos de la mujer, comunidades marginadas y apoyo a los docentes, buscamos desarrollar programas y actividades en el sector público y privado, que promuevan la formación integral, reconocimiento y estimulación a los docentes que con su liderazgo participan en la construcción de una sociedad justa y responsable con sus integrantes.";
  
  const textoVisionCompleto = "Siendo la educación una base fundamental del desarrollo de la sociedad, buscamos contribuir con el reconocimiento de la labor del docente, enfocarnos en promover educación de calidad a la sociedad con alternativas que potencien actividades como la agroindustria, la cultura, fomentando así la economía y el desarrollo de comunidades vulnerables, que no acceden a sus derechos fundamentales.";

  // Array con la información detallada original de los objetivos
  const objetivosOriginales = [
    "Exaltar la labor docente mediante la entrega de reconocimientos e incentivos que valoren su impacto en la sociedad.",
    "Favorecer la formación complementaria de los docentes en cuanto a los procesos académicos de su especialidad y los vinculados a la realidad social del posconflicto.",
    "Promover procesos direccionados a la creación de oportunidades económicas para el beneficio de los docentes.",
    "Contribuir al bienestar y salud de los docentes y sus familias con planes que les permitan acceso a opciones para tratamientos de salud y medicamentos.",
    "Promover procesos direccionados a la creación de oportunidades económicas para el beneficio de los docentes y las comunidades marginadas.",
    "Propender en la creación y mejoramiento de centros educativos en las comunidades vulnerables.",
    "Fomentar la agroindustria y la cultura, como vías de generación y reactivación de la economía de las entidades más necesitadas.",
    "Establecimiento de campañas de esparcimiento, salud y atención a niños, jóvenes, mujeres de comunidades donde desarrolle actividades FundadocenteJDD."
  ];

  const abrirModal = (titulo, contenido) => {
    setModalData({ open: true, title: titulo, text: contenido });
    document.body.style.overflow = 'hidden';
  };

  const cerrarModal = () => {
    setModalData({ ...modalData, open: false });
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <div className='bg-gray-50  min-h-screen py-8 md:py-12 relative'>
        <div className='max-w-6xl mt-10 mx-auto px-4 md:px-6'>
          
          <div className='text-center mb-12 md:mb-16'>
            <h1 className='text-3xl md:text-5xl font-black text-slate-900 mb-4'>Nuestra Identidad</h1>
            <div className='w-16 md:w-24 h-1.5 bg-blue-600 mx-auto rounded-full'></div>
          </div>

          <div className='grid md:grid-cols-2 gap-6 md:gap-8 mb-12'>
            {/* Carta Misión */}
            <div 
              onClick={() => abrirModal("Misión", textoMisionCompleto)}
              className='bg-white p-8 md:p-10 rounded-[1.5rem] md:rounded-[2.5rem] shadow-sm border border-gray-100 hover:shadow-xl transition-all cursor-pointer group'
            >
              <div className='flex items-center gap-4 mb-4 md:mb-6'>
                <div className='bg-blue-50 p-3 rounded-xl group-hover:bg-blue-600 transition-colors'>
                  <TbTargetArrow className='text-blue-600 text-3xl group-hover:text-white transition-colors' />
                </div>
                <h2 className='text-xl md:text-2xl font-bold text-slate-800 uppercase'>Misión</h2>
              </div>
              <p className='text-slate-600 leading-relaxed text-lg font-light'>
                Somos una entidad sin ánimo de lucro que resalta la importancia del trabajo pedagógico y el desarrollo educativo...
              </p>
              <div className='mt-4 text-blue-600 font-bold text-xs tracking-widest uppercase flex items-center gap-2'>
                Leer completo <span>→</span>
              </div>
            </div>

            {/* Carta Visión */}
            <div 
              onClick={() => abrirModal("Visión", textoVisionCompleto)}
              className='bg-white p-8 md:p-10 rounded-[1.5rem] md:rounded-[2.5rem] shadow-sm border border-gray-100 hover:shadow-xl transition-all cursor-pointer group'
            >
              <div className='flex items-center gap-4 mb-4 md:mb-6'>
                <div className='bg-blue-50 p-3 rounded-xl group-hover:bg-blue-600 transition-colors'>
                  <TbEye className='text-blue-600 text-3xl group-hover:text-white transition-colors' />
                </div>
                <h2 className='text-xl md:text-2xl font-bold text-slate-800 uppercase'>Visión</h2>
              </div>
              <p className='text-slate-600 leading-relaxed text-lg font-light'>
                Buscamos ser el referente en el reconocimiento de la labor docente y en la promoción de educación de calidad...
              </p>
              <div className='mt-4 text-blue-600 font-bold text-xs tracking-widest uppercase flex items-center gap-2'>
                Leer completo <span>→</span>
              </div>
            </div>
          </div>

          {/* Objetivos Cliqueables */}
          <div className='bg-white p-8 md:p-16 rounded-[1.5rem] md:rounded-[3rem] shadow-sm border border-gray-100'>
            <div className='flex items-center gap-4 mb-8 md:mb-12'>
              <div className='bg-blue-50 p-3 rounded-xl text-blue-600'>
                <TbChecklist size={32} />
              </div>
              <h2 className='text-2xl md:text-3xl font-bold text-slate-800'>Nuestros Objetivos</h2>
            </div>

            <div className='grid md:grid-cols-2 gap-x-12 gap-y-2 md:gap-y-4'>
              {[
                "Exaltar la labor docente mediante reconocimientos e incentivos.",
                "Favorecer la formación complementaria en procesos académicos.",
                "Promover la creación de oportunidades económicas para docentes.",
                "Contribuir al bienestar y salud de los docentes y sus familias.",
                "Impulsar oportunidades para comunidades marginadas.",
                "Propender en el mejoramiento de centros educativos.",
                "Fomentar la agroindustria y cultura como vías de reactivación.",
                "Establecer campañas de salud y atención para la juventud."
              ].map((obj, index) => (
                <div 
                  key={index} 
                  onClick={() => abrirModal("Objetivo Institucional", objetivosOriginales[index])}
                  className='flex gap-4 items-start group cursor-pointer hover:bg-blue-50 p-3 rounded-xl transition-all'
                >
                  <span className='mt-2.5 w-1.5 h-1.5 rounded-full bg-blue-500 shrink-0 group-hover:scale-150 transition-transform'></span>
                  <p className='text-slate-600 text-base md:text-lg font-light leading-snug group-hover:text-blue-700'>
                    {obj}
                  </p>
                </div>
              ))}
            </div>
            <p className='text-slate-400 text-sm mt-8 italic'>* Haz clic en cualquier objetivo para expandir la información.</p>
          </div>
        </div>

        {/* MODAL RESPONSIVO */}
        {modalData.open && (
          <div className="fixed inset-0 z-[1000] flex items-end sm:items-center justify-center p-0 sm:p-4">
            <div 
              className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
              onClick={cerrarModal}
            ></div>

            <div className="bg-white w-full max-w-2xl rounded-t-[2rem] sm:rounded-[2.5rem] p-6 md:p-12 shadow-2xl relative z-10 max-h-[90vh] flex flex-col overflow-hidden animate-in slide-in-from-bottom sm:zoom-in-95 duration-300">
              
              <button 
                onClick={cerrarModal}
                className="absolute top-4 right-4 p-2 text-slate-400 hover:text-red-500 transition-colors"
              >
                <TbX size={28} />
              </button>

              <div className="overflow-y-auto pr-2 custom-scrollbar">
                <div className="space-y-4 md:space-y-6">
                  <div className="inline-block px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-[10px] font-bold tracking-widest uppercase">
                    Detalle de Información
                  </div>
                  <h2 className="text-2xl md:text-4xl font-black text-slate-900 leading-tight">
                    {modalData.title}
                  </h2>
                  <div className="w-12 h-1 bg-blue-600 rounded-full"></div>
                  
                  <p className="text-slate-700 text-lg md:text-xl leading-relaxed font-light italic border-l-4 border-blue-100 pl-4">
                    {modalData.text}
                  </p>
                </div>
              </div>

              <button 
                onClick={cerrarModal}
                className="mt-8 w-full bg-slate-900 text-white py-4 rounded-xl md:rounded-2xl font-bold hover:bg-blue-600 transition-all shadow-lg shrink-0"
              >
                Entendido
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Mision;